const validators = {
    checkbox: {
        parameters: ["mustbetrue"],
        isValid: function (value, element, params) {
            if (params && params.mustbetrue === "true") {
                return element.checked === true;
            }
            return true;
        },
        unpack: function (options) {
            if (options.params.mustbetrue) {
                options.rules["checkbox"] = options.params;
                options.messages["checkbox"] = options.message;
            }
        }
    }
};

export { validators };